import { createRef, useRef } from "react";
// import { LanguageItem } from "types/generalTypes";

export const languages = createRef<any[]>();
